import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";

export interface ShopConfigAuditLogDto {
  id: string;
  shopId: string;
  userId?: string | null;
  userEmail?: string | null;
  action: string;
  field: string;
  before?: unknown;
  after?: unknown;
  createdAt: number;
}

type UseGetShopConfigAuditLogsParams = {
  shopId: string;
  field?: string;
  limit?: number;
  skip?: number;
  enabled?: boolean;
};

export function useGetShopConfigAuditLogs({
  shopId,
  field,
  limit,
  skip,
  enabled = true,
}: UseGetShopConfigAuditLogsParams) {
  return useQuery<ShopConfigAuditLogDto[]>({
    queryKey: ["get", "config-audit-logs", { shopId, field, limit, skip }],
    queryFn: async () => {
      const response = await fetchClient.GET(
        // @ts-expect-error endpoint not yet in generated types — run pnpm codegen after backend is up
        "/shops/{shopId}/config-audit-logs",
        {
          params: {
            path: { shopId },
            query: { field, limit, skip },
          },
        },
      );
      return (response.data ?? []) as ShopConfigAuditLogDto[];
    },
    enabled,
  });
}
